import {
    Button,
    Typography
}                        from "@mui/material";
import {useZINContext}   from "../context/ZinContextProvider";

const DeleteForm = () =>
{
    const {setModalVisible, deleteCallback} = useZINContext()

    function onClickSubmit()
    {
        deleteCallback.delete()
        setModalVisible(false)
    }

    return (<>

        <Typography id="modal-modal-title" variant="h6" component="h2">
            Weet je zeker dat je dit item wil verwijderen?
        </Typography>
        <Button className={"od-button"} variant="contained" onClick={onClickSubmit}>Verwijderen</Button>
        <Button className={"od-button"} variant="contained" onClick={() => setModalVisible(false)}>Annuleren</Button>
    </>)
}
export default DeleteForm